import {
  ANNUAL_MASK_STATUS,
  ANNUAL_MASK_SOCIAL_SECURITY_DECISION,
  getAnnualMaskSocialSecurityDecision,
  getAnnualMaskSelectedSaleName,
  isAnnualMaskReceiptDateValid,
  isAnnualMaskOrderComplete,
} from "./annualMaskPurchaseUtils";

export const getAnnualMaskWorkflowProgress = (caseItem = {}) => {
  const decision = getAnnualMaskSocialSecurityDecision(caseItem);
  const signedSkipped = Boolean(caseItem.signedCertificateUploadSkip && caseItem.signedCertificateUploadSkip.confirmed);
  const doctorSkipped = caseItem.status === ANNUAL_MASK_STATUS.DOCTOR_STEP_SKIPPED;
  const done = (value) => value ? "complete" : "pending";
  return [
    { key: "doctor", label: "Send to doctor", state: caseItem.doctorEmailSent ? "complete" : doctorSkipped ? "skipped" : "pending" },
    { key: "certificate", label: "Signed medical certificate", state: caseItem.signedMedicalCertificate ? "complete" : signedSkipped ? "skipped" : "pending" },
    { key: "socialSecurity", label: "Social Security", state: decision === ANNUAL_MASK_SOCIAL_SECURITY_DECISION.NOT_PASSED ? "failed" : done(decision === ANNUAL_MASK_SOCIAL_SECURITY_DECISION.PASSED) },
    { key: "mask", label: "Select mask type", state: done(caseItem.selectedMask && caseItem.selectedMask.accessoryId) },
    { key: "sale", label: "Select Sales Representative", state: done(getAnnualMaskSelectedSaleName(caseItem)) },
    { key: "receipt", label: "Expected mask receipt date", state: done(isAnnualMaskReceiptDateValid(caseItem.maskReceiptDate)) },
    { key: "ready", label: "Ready to purchase", state: done(caseItem.saleOrderId || [ANNUAL_MASK_STATUS.READY_TO_PURCHASE, ANNUAL_MASK_STATUS.ORDER_CREATED, ANNUAL_MASK_STATUS.ORDER_COMPLETED].includes(caseItem.status)) },
    { key: "completed", label: "เสร็จสิ้น", state: done(isAnnualMaskOrderComplete(caseItem)) },
  ];
};
